import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { customToast } from "../../../../components/notify/NotifyContainer";
import useDeleteFbFanPage from "./useDeleteFbFanPage";
import useFbPageQuery from "./useFbPageQuery";

const useBindFbFanPage = () => {
    const { characterId } = useParams();

    const { fbFanPageBot, isLoading } = useFbPageQuery({ characterId });
    const fb_bot_id = fbFanPageBot?.id;
    const { handleDelete, deleteLoading, deleteSuccess } = useDeleteFbFanPage();

    const handleUnBindFB = () => {
        if (fb_bot_id) handleDelete(fb_bot_id);
    };

    useEffect(() => {
        if (deleteSuccess) {
            customToast.success("Successful");
        }
    }, [deleteSuccess]);

    return {
        handleUnBindFB,
        fbFanPageBot,
        handleDelete,
        deleteLoading,
        pageLoading: isLoading,
        isBindFb: !!fbFanPageBot,
    };
};
export default useBindFbFanPage;
